var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceClone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 10125598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.95507 26.3855V16.614C1.95507 16.0735 1.51805 15.6365 0.977532 15.6365C0.437014 15.6365 0 16.0735 0 16.614V26.3855C0 26.926 0.437014 27.363 0.977532 27.363C1.51805 27.363 1.95507 26.926 1.95507 26.3855Z",
    fill: "url(#paint0_linear_2606_63246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.8413 35.1819C7.38182 35.1819 7.81884 34.7449 7.81884 34.2044V8.79614C7.81884 8.25562 7.38182 7.8186 6.8413 7.8186C6.30079 7.8186 5.86377 8.25562 5.86377 8.79614V34.2044C5.86377 34.7449 6.30079 35.1819 6.8413 35.1819Z",
    fill: "url(#paint1_linear_2606_63246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.7041 43C13.2446 43 13.6816 42.563 13.6816 42.0225V0.977532C13.6816 0.437013 13.2446 0 12.7041 0C12.1636 0 11.7266 0.437013 11.7266 0.977532V42.0225C11.7285 42.563 12.1655 43 12.7041 43Z",
    fill: "url(#paint2_linear_2606_63246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.5674 41.0449C19.1079 41.0449 19.5449 40.6079 19.5449 40.0674V2.93261C19.5449 2.39209 19.1079 1.95508 18.5674 1.95508C18.0269 1.95508 17.5898 2.39209 17.5898 2.93261V40.0674C17.5918 40.6079 18.0288 41.0449 18.5674 41.0449Z",
    fill: "url(#paint3_linear_2606_63246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.4326 33.2266C24.9731 33.2266 25.4101 32.7896 25.4101 32.2491V10.751C25.4101 10.2105 24.9731 9.77344 24.4326 9.77344C23.8921 9.77344 23.4551 10.2105 23.4551 10.751V32.251C23.4551 32.7896 23.8921 33.2266 24.4326 33.2266Z",
    fill: "url(#paint4_linear_2606_63246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M30.2959 41.0449C30.8364 41.0449 31.2734 40.6079 31.2734 40.0674V2.93261C31.2734 2.39209 30.8364 1.95508 30.2959 1.95508C29.7554 1.95508 29.3184 2.39209 29.3184 2.93261V40.0674C29.3184 40.6079 29.7554 41.0449 30.2959 41.0449Z",
    fill: "url(#paint5_linear_2606_63246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M36.1592 33.2266C36.6997 33.2266 37.1367 32.7896 37.1367 32.2491V10.751C37.1367 10.2105 36.6997 9.77344 36.1592 9.77344C35.6187 9.77344 35.1816 10.2105 35.1816 10.751V32.251C35.1816 32.7896 35.6187 33.2266 36.1592 33.2266Z",
    fill: "url(#paint6_linear_2606_63246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M42.0225 15.6365C41.4819 15.6365 41.0449 16.0735 41.0449 16.614V26.3855C41.0449 26.926 41.4819 27.363 42.0225 27.363C42.563 27.363 43 26.926 43 26.3855V16.614C43 16.0735 42.563 15.6365 42.0225 15.6365Z",
    fill: "url(#paint7_linear_2606_63246)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2606_63246",
    x1: 0.342137,
    y1: 26.337,
    x2: 2.34439,
    y2: 26.1701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73E49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#3FC36D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2606_63246",
    x1: 6.20591,
    y1: 32.7876,
    x2: 8.2195,
    y2: 32.7157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73E49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#3FC36D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2606_63246",
    x1: 12.0687,
    y1: 39.2375,
    x2: 14.0838,
    y2: 39.1917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73E49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#3FC36D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2606_63246",
    x1: 17.932,
    y1: 37.6246,
    x2: 19.9469,
    y2: 37.5742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73E49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#3FC36D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2606_63246",
    x1: 23.7972,
    y1: 31.1744,
    x2: 25.8099,
    y2: 31.0905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73E49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#3FC36D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2606_63246",
    x1: 29.6605,
    y1: 37.6246,
    x2: 31.6754,
    y2: 37.5742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73E49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#3FC36D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2606_63246",
    x1: 35.5238,
    y1: 31.1744,
    x2: 37.5364,
    y2: 31.0905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73E49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#3FC36D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2606_63246",
    x1: 41.3871,
    y1: 26.337,
    x2: 43.3893,
    y2: 26.1701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73E49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#3FC36D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceClone);
export default __webpack_public_path__ + "static/media/VoiceClone.179caa180513ade2389b9955195f2811.svg";
export { ForwardRef as ReactComponent };